import styles from "./part4.module.scss";
export default function HomePart2() {
  const listArr = [
    {
      pic: "/img/img_numbers.png",
      title: "Multiple Numbers on One Phone",
      desc: "You can pick a 2nd phone number to separate life and business. Multiple numbers can be used on one phone with Dingtone app applied.",
    },
    {
      pic: "/img/img_earth.png",
      title: "Calling Codes for Multiple Countries",
      desc: "Dingtone provides real phone numbers for US, UK, Canada, Australia, etc. and ones with local area codes to unlimitedly call and text with Internet.",
    },
    {
      pic: "/img/img_features.png",
      title: "Business Phone Features",
      desc: "Dingtone app also provides business phone features to boost business through calling such as voicemail, call forwarding, block call, etc.",
    },
  ];
  return (
    <div className={styles.part3 + " main"}>
      <div className={styles.inner + " flex-r"}>
        <div className={styles.right}>
          <img src="/img/img_map.png" alt="Boundary Free International Calls" />
        </div>

        <div className={styles.left}>
          <h5>Cheap International Calls via WiFi</h5>
          <h2>Boundary Free International Calls</h2>
          <p>
            Dingtone app allows you to make unlimited international calls and
            SMS with low rates or even for free from your cell phone to any
            mobile or landline phone number in over 200 countries.
          </p>
        </div>
      </div>
    </div>
  );
}
